export default "__VITE_ASSET__wBd9OWk5__"